import React from "react";
import IconDadhero from "../../../../assets/img/dadhero/dociekliwosc_dziennikarska_dadhero.svg"

import AttachmentContentBase from "../../../../redesign/components/AttachmentBase";
import { AttachmentElement } from "../../../../components/Article/Parts/Slate/types"


type AttachmentProps = {
    element: AttachmentElement;
};

const AttachmentContent: React.FC<AttachmentProps> = ({
    element,
}) => {

    return (
        <AttachmentContentBase element={element} icon={IconDadhero} />
    );
};

export default AttachmentContent;